import type { RawParams } from "@uirouter/core";

import type { ApiPageType } from "app/pages/sales-intelligence/modules/manage-integrations/types/api-page-type";
import type { RequestAdminFeatureBase } from "app/pages/sales-intelligence/types/requestAdminFeature";

import { DEFAULT_GATEWAY_PAGE_TITLE_KEY, GATEWAY_PAGE_TITLE_KEY } from "../constants/gateway-pages";

export type GatewayPageTitleParams = RawParams & {
    featureName?: ApiPageType | RequestAdminFeatureBase;
};

export const resolveGatewayPageTitle = (params?: GatewayPageTitleParams): string => {
    const featureName = params?.featureName;

    return featureName && featureName in GATEWAY_PAGE_TITLE_KEY
        ? GATEWAY_PAGE_TITLE_KEY[featureName]
        : DEFAULT_GATEWAY_PAGE_TITLE_KEY;
};
